import { Cascader } from 'antd';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { notifyError } from '../store/utils';
import { API } from '../api';

interface AddressCascaderProps {
  value?: string[];
  disabled?: boolean;
  onChange?: (value: (string | number | null)[]) => void;
}

const AddressCascader: React.FC<AddressCascaderProps> = ({ value, disabled, onChange }) => {
  const [state, updateState] = useState<any[]>([]);

  const fetchFullAddress = useCallback(async () => {
    try {
      const { result } = await API.get({ apiVersion: 'api' })(`/address/full`);
      updateState(result?.data || []);
    } catch (error: any) {
      notifyError(error.message);
    }
  }, []);

  useEffect(() => {
    fetchFullAddress();
  }, []);

  const options = useMemo(() => {
    const items = state.map((item: any) => {
      return {
        value: item.no,
        label: item.name,
        zipcode: item.zipcode,
        children: (item.districts || []).map((district: any) => {
          return {
            value: district.no,
            label: district.name,
            zipcode: district.zipcode,
            children: (district.streets || []).map((street: any) => {
              return {
                value: street.no,
                zipcode: street.zipcode,
                label: street.description ? `${street.description}, ${street.name}` : street.name,
              };
            }),
          };
        }),
      };
    });
    return items;
  }, [state]);

  return (
    <Cascader
      showSearch={{
        filter: (inputValue, path) =>
          path.some(
            (option) =>
              option.zipcode?.includes(inputValue) ||
              option.label.toLowerCase().includes(inputValue.toLowerCase())
          ),
      }}
      options={options}
      value={value}
      disabled={disabled}
      onChange={onChange}
    />
  );
};

export default AddressCascader;
